import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

class OrganizationTypeRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.requestShowOrganizationSyncPermissions = this.requestShowOrganizationSyncPermissions.bind(this);
  }

  requestShowOrganizationSyncPermissions() {
    this.props.requestShowOrganizationSyncPermissions(this.props.data);
  }

  render() {
    const { data, value, node } = this.props;
    if (!value || data?.is_demo || (!data && !node?.group)) {
      return null;
    }
    let display = value;
    let cls = 'label-default';
    let btnStyle = 'default';

    if (value === 'force') {
      display = 'SALESFORCE';
      cls = 'label-success';
      btnStyle = 'success';
    } else if (value === 'azure') {
      display = 'DYNAMICS';
      cls = 'label-warning';
      btnStyle = 'warning';
    } else if (value === 'hubspot') {
      display = 'HUBSPOT';
      cls = 'label-danger';
      btnStyle = 'danger';
    }
    if (data && data.organization_id) {
      return (
        <Button bsStyle={btnStyle} bsSize="xs" onClick={this.requestShowOrganizationSyncPermissions}>{display}</Button>
      );
    }
    return (
      <span className={`label ${cls}`}>{display}</span>
    );
  }
}

OrganizationTypeRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    is_demo: PropTypes.bool,
    type: PropTypes.string,
    organization_id: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  requestShowOrganizationSyncPermissions: PropTypes.func,
};
OrganizationTypeRenderer.defaultProps = {
  value: null,
  data: null,
  requestShowOrganizationSyncPermissions: () => {},
};

export default OrganizationTypeRenderer;
